import React from 'react'
import grn from '../Assets/green_bg.png'
import red from '../Assets/red_bg.png'

const K3Ball = ({ addBall, i }) => {
  return (
    <div onClick={() => addBall(i)} className='flex flex-col justify-center items-center'>

    <div className='relative cursor-pointer flex justify-center items-center'>
        { i % 2 !== 0 && <img className='image max-w-[34px] max-h-[34px]' src={red} alt='' />}      
        { i % 2 === 0 && <img className='max-w-[34px] max-h-[34px]' src={grn} alt=''/>}
        <p className={`absolute text-center font-bold ${i % 2 !== 0 && 'text-red-500'} ${i % 2 === 0  && 'text-green-500'}`}>{i}</p>
    </div>
        {i >= 9 && i <= 12 && <p className='text-black '>6</p>}
        {i === 18 && <p className='text-black '>185</p>}
        {i === 3 &&  <p className='text-black '>185</p>}
        {i === 4 &&  <p className='text-black '>50</p>}
        {i === 17 &&  <p className='text-black '>50</p>}
        {i === 16 &&  <p className='text-black '>18</p>}
        {i === 5 &&  <p className='text-black '>18</p>}
        {i === 6 &&  <p className='text-black '>14</p>}
        {i === 15 &&  <p className='text-black '>14</p>}
        {i === 14 &&  <p className='text-black '>12</p>}
        {i === 7 &&  <p className='text-black '>12</p>}
        {i === 8 &&  <p className='text-black '>8</p>}
        {i === 13 &&  <p className='text-black '>8</p>}
    </div>
  )
}

export default K3Ball